import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { AuthState } from '.';
import { loginAction } from './actions';

export const extraReducers = (builder: ActionReducerMapBuilder<AuthState>) => {
  builder.addCase(loginAction.pending, (state: AuthState) => {
    state.loading = true;
  });
  builder.addCase(loginAction.fulfilled, (state: AuthState, { payload }: PayloadAction<any>) => {
    state.branch = payload?.branch || {};
    state.company = payload?.company || {};
    state.userId = payload?.userId || '';
    state.loading = false;
  });
  builder.addCase(loginAction.rejected, (state: AuthState) => {
    state.loading = false;
  });
};
